import { installNavigation } from '@shared-core/navigation'
import { ElectronDragHeader } from '@web/components/electron-drag-header'
import { WebNavigationAdapter } from '@web/libs/navigation/web-adapter'
import { router } from '@web/router'
import { RouterProvider } from 'react-router-dom'

// Платформа на старте регистрирует свой адаптер: installNavigation(WebNavigationAdapter).
installNavigation(WebNavigationAdapter)

export function App() {
  return (
    <>
      <ElectronDragHeader />
      <RouterProvider router={router} />
    </>
  )
}
